import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export var ValidationException = /*#__PURE__*/function (_Error) {
  function ValidationException() {
    var _this;
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, ValidationException);
    _this = _callSuper(this, ValidationException, ['Validation Error']);
    _defineProperty(_this, "name", 'ValidationException');
    _defineProperty(_this, "errors", []);
    _this.errors = errors;
    return _this;
  }
  _inherits(ValidationException, _Error);
  return _createClass(ValidationException, [{
    key: "getErrors",
    value: function getErrors() {
      console.log('this.errors', this.errors);
      return this.errors;
    }
  }, {
    key: "extractErrorMessageFrom",
    value: function extractErrorMessageFrom(keys) {
      return this.errors.filter(function (error) {
        return keys.includes(error.name);
      }).map(function (error) {
        return error.message;
      }).join(', ') || "";
    }
  }, {
    key: "isError",
    value: function isError(key) {
      return this.errors.some(function (error) {
        return error.name === key;
      });
    }
  }, {
    key: "getAllErrorMessages",
    value: function getAllErrorMessages() {
      return this.errors.map(function (error) {
        return error.message;
      }).join('\n');
    }
  }], [{
    key: "factoryFromAxios",
    value: function factoryFromAxios(error) {
      var _error$data, _error$response, _error$response$data, _error$response2, _error$response2$data, _exp$errors;
      var exp = new ValidationException();
      // normalized {key: value }[] format
      if (error !== null && error !== void 0 && (_error$data = error.data) !== null && _error$data !== void 0 && _error$data.validation_errors) {
        exp.errors = error.data.validation_errors.map(function (entry) {
          var key = Object.keys(entry)[0];
          return {
            name: key,
            message: entry[key]
          };
        });
        return exp;
      }
      exp.errors = (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.errors) || (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.validation_errors) || [];
      if (exp.errors.length === 0) {
        var _error$data2, _error$data4;
        if (Array.isArray(error === null || error === void 0 ? void 0 : (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.errors)) {
          var _error$data3;
          exp.errors = error === null || error === void 0 ? void 0 : (_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : _error$data3.errors;
        } else if (Object.keys((error === null || error === void 0 ? void 0 : (_error$data4 = error.data) === null || _error$data4 === void 0 ? void 0 : _error$data4.errors) || {}).length > 0) {
          var _error$data5;
          exp.errors = Object.keys(error === null || error === void 0 ? void 0 : (_error$data5 = error.data) === null || _error$data5 === void 0 ? void 0 : _error$data5.errors).map(function (key) {
            var _error$data6;
            return {
              name: key,
              message: error === null || error === void 0 ? void 0 : (_error$data6 = error.data) === null || _error$data6 === void 0 ? void 0 : _error$data6.errors[key]
            };
          });
        }
      } else if (((_exp$errors = exp.errors) === null || _exp$errors === void 0 ? void 0 : _exp$errors.length) > 0 && !exp.errors[0].message) {
        exp.errors = exp.errors.map(function (item) {
          var key = Object.keys(item)[0];
          return {
            name: key,
            message: item[key]
          };
        });
      }
      return exp;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));